/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Kiotviet_Sync_FailedInputs */

const vi_customer_kiotviet_sync_failed = /** @type {(inputs: Customer_Kiotviet_Sync_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đồng bộ KiotViet thất bại`)
};

/**

* @param {Customer_Kiotviet_Sync_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_kiotviet_sync_failed = /** @type {((inputs?: Customer_Kiotviet_Sync_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Kiotviet_Sync_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_kiotviet_sync_failed(inputs)
});